import { ActionTree } from 'vuex'
import {
  getCompanyList,
  getPrivateConfig
} from '@/apps/open/services/plussvr'
import store from '@/apps/open/store'

const actions: ActionTree<any, any> = {
  SET_INTERPRISE_INFO: async ({ commit, rootGetters }, params: any) => {
    let res: any = void 0
    if (!rootGetters.isPriDocEdit) {
      res = await getCompanyList(params)
    }
    const enterpriseList = res ? res.data.companies : []
    // 筛选超管企业
    const hasSurperAdminList = enterpriseList.filter((item: any) => item.role_id === 1)

    if (hasSurperAdminList.length <= 0) {
      commit('SET_IS_JOIN_ENTERPRISE_PLUS', false)
    } else if (hasSurperAdminList.length > 0) {
      commit('SET_IS_JOIN_ENTERPRISE_PLUS', true)
    }
    commit('SET_ENTERPRISE_LIST', hasSurperAdminList)
  },
  GET_PRIVATE_CONFIG: async ({ commit }) => {
    try {
      const res = await getPrivateConfig()
      const appConf = res.data.applications[0]
      commit('SET_PRI_CONF', appConf)
    } catch {
      commit('SET_PRI_CONF', null)
    }
  }
}

export default actions
